<wl-top-banner
  *ngIf="title"
  (handleClickEvent)="onClick()"
  [hideLink]="hideLink"
  [hideSubtitle]="hideSubtitle"
  [linkText]="'Go to quote summary'"
  [subtitle]="'Or continue adding appliances below'"
  [title]="title"
></wl-top-banner>
